// extracted by mini-css-extract-plugin
export default {"geniusHighlightTooltipButton":"FlightCardGeniusHighlightTooltipWrapper-module__geniusHighlightTooltipButton___ArGiB"};